/* eslint-disable max-classes-per-file */

import queryString from 'query-string';

import { GeneratedReport, GeneratedReportStatus, GenerationJob } from '../../models/report';
import { ApplicationResult } from '../../../utilities/post-notification-handler';
import { applicationParameters } from '../../../utilities/application-parameters';

export type ReportsResultProps = {
  reports: GeneratedReport[];
};

export class ApplicationReportsResult implements ApplicationResult {
  private reports: GeneratedReport[];

  constructor(
    reports: GeneratedReport[],
    public customerReferenceId = applicationParameters.get('customerReferenceId')
  ) {
    this.reports = reports;
  }

  private buildResult() {
    const result: Record<string, string> = {};

    this.reports.forEach((report) => {
      result[report.idParameterName] = report.reportId;
    });

    return result;
  }

  buildQueryPath() {
    const additionalInformation: Record<string, string> = {};

    if (this.customerReferenceId) {
      // eslint-disable-next-line dot-notation
      additionalInformation['customer_reference_id'] = this.customerReferenceId;
    }

    return queryString.stringify({ ...additionalInformation, ...this.buildResult() });
  }

  // eslint-disable-next-line class-methods-use-this
  buildIframeMessage() {
    const additionalInformation: Record<string, string> = {};

    if (this.customerReferenceId) {
      // eslint-disable-next-line dot-notation
      additionalInformation['customerReferenceId'] = this.customerReferenceId;
    }

    return JSON.stringify({
      type: 'reports',
      data: this.buildResult(),
      additionalInformation,
    });
  }
}

export class ApplicationAsyncReportsResult extends ApplicationReportsResult {
  constructor(job: GenerationJob) {
    super([
      {
        idParameterName: 'reports_generation_job_id',
        reportId: job.id,
        reportType: 'GENERATION_JOB',
        status: GeneratedReportStatus.COMPLETED,
      },
    ]);
  }
}
